module.exports = __webpack_public_path__ + "static/media/dealer_a_1280.c6ea286a.png";